import Vue from 'vue';
import router from '../router';
import { saveAs } from 'file-saver';
import {firestore} from '@/firebase.js';

export default {
    state:{
      ready:false,
      cargando:false,
      cargando_pdf:false,
      opcion_activa:'',
      mensajes_no_leidos:0,
      opcion_activa_descripcion:'',
      chartColors:[
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ],
      parametros:{
        test:null,
        cliente:null,
        empleado:null,
        prueba:null
      }
    },
    mutations: {
      setOpcionActiva(state,opcion_activa){
        state.opcion_activa=opcion_activa;
      },
      setMensajeNoLeido(state){
        state.mensajes_no_leidos=state.mensajes_no_leidos+1;
      }
    },
    actions: {
      ConsultarMensajesNoLeidos(context){
        context.state.mensajes_no_leidos=0;
        firestore.collection('mensajes')
        .where('estatus','==',1)
        .get().then(querySnapshot=>{
            querySnapshot.forEach(doc=>{
              context.commit('setMensajeNoLeido');
            });
        });
      },
      ActualizarOpcionActiva(context,opcion_activa){
        context.commit('setOpcionActiva',opcion_activa);
      },
      ImprimirPDF(context,pdf){
        let element = pdf.element;
        let filename=pdf.filename;
        context.state.cargando_pdf=true;
        console.log(element);
        Vue.http.post('https://api.html2pdf.app/v1/generate',
        {
          html:'<!DOCTYPE html><html lang="mx"><head><link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous"></head><body><div class="container-fluid ml-3 mr-5 pr-5 mt-5">'+element+'</div></body></html>',
          apiKey:'2c22ec5af5c3901f14e12055412b4c246de006b774483e7735d42f1899435ed7',
          format:'Letter',
          marginTop:0,
          marginRight:0,
          marginBottom:0,
          marginLeft:0,
        },
        {
          responseType: 'blob', 
          headers: {
            "Accept":"application/pdf"
          }
        })
        .then(respuesta=>{
          context.state.cargando_pdf=false;
          saveAs(respuesta.bodyBlob, filename+'.pdf');
        })
        .catch(error=>{
          context.state.cargando_pdf=false;
          swal('Problemas para descargar pdf','','error');
        });
      }
    },
    getters: {  
      getOpcionActiva(state){
        return state.opcion_activa;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/menu.js